<template>
    <v-file-input
        ref="file-input"
        v-model="file"
        :disabled="disabled"
        :rules="rulesDelegate"
        :show-size="showSize"
        :hint="hint"
        :append-icon="appendIcon"
        :persistent-hint="persistentHint"
        :multiple="false"
    />
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({
    name: 'SingleFileInput',
})
export default class SingleFileInput extends Vue {
    @Prop({ default: undefined }) readonly value: File | null | undefined;
    @Prop({ default: false }) readonly disabled: boolean;
    @Prop({ type: [Boolean, Number], default: undefined }) readonly showSize: boolean | number | undefined;
    @Prop({ default: undefined }) readonly hint: string | undefined;
    @Prop({ default: undefined }) readonly appendIcon: string | undefined;
    @Prop({ default: undefined }) readonly persistentHint: boolean | undefined;
    @Prop({ default: () => [] }) readonly rules: Array<boolean | string | ((val: File) => boolean)>;

    file: File | null = null;

    @Watch('file')
    onFileInput(file) {
        this.inputFile(file);
    }

    /*
     * setters, getters
     */
    get rulesDelegate(): Array<boolean | string> {
        const file = this.value;

        return this.rules.map(r => {
            if (typeof r === 'function') {
                return r(file);
            } else {
                return r;
            }
        });
    }

    /*
     * methods
     */
    inputFile(newValue: File | Array<File> | null | undefined) {
        let emitVal: File | null = null;

        // multiple=false でも配列で渡されるケースがあるのでその対応
        // このコンポーネントのv-modelはFileオブジェクト単独とする
        if (Array.isArray(newValue)) {
            if (newValue.length > 0) {
                emitVal = newValue[0];
            }
        } else if (newValue?.constructor === File) {
            emitVal = newValue;
        }

        this.$emit('input', emitVal);
    }
    public reset() {
        const r = (this as any).$refs['file-input'];
        if (r) {
            r.reset();
        }
    }
}
</script>
